import type { API } from 'api/config/types';
import { TimeControl } from 'chessboard/api/time-control/config/types';

/**
 * Create the getTimeControl method.
 */
export function createGetTimeControl(context: API.Context) {
  /**
   * Get the current time control.
   */
  return function getTimeControl(): TimeControl.Model | null {
    const timeControlStr = context.api.getHeaders().TimeControl;

    if (
      !timeControlStr ||
      timeControlStr === TimeControl.Header.Null ||
      timeControlStr.includes(TimeControl.Header.Unset) ||
      timeControlStr.includes(TimeControl.Header.TimePerMove)
    ) {
      return null;
    }

    const [baseTime, increment] = timeControlStr
      .split(TimeControl.Header.Separator)
      .map((secondsString: string) => Math.round(parseFloat(secondsString) * 1000));

    return { baseTime, increment: increment || 0 };
  };
}
